import Vue from "vue"
import vueRouter from "vue-router"
import store from "@/store/store.js"
import { Message } from "element-ui";
import { setLastModulePath } from "@/utils/lastModule.js";
Vue.use(vueRouter)

const routes = [
	{
		path: "*",
		redirect: '/login'
	},
	{
		path: "/login",
		component: () => import("@/view/loginPage/index.vue"),
		meta: {
			keepAlive: false
		}
	},
	{
		path: "/homePage",
		component: () => import("@/view/homePage/index.vue"),
		redirect: '/homePage/customerOrder',
		children: [
			{
				path: "indexPage",
				component: () => import("@/view/indexPage/index.vue"),					// 首页
				meta: {
					keepAlive: false
				}
			},
			{
				path: "customerOrder",
				component: () => import("@/view/customerOrder/index.vue"),				// 销售订单
				meta: {
					keepAlive: true
				}
			},
			{
				path: "productionOrder",
				component: () => import("@/view/productionOrder/index.vue"),			// 组装工单
				meta: {
					keepAlive: true
				}
			},
			{
				path: "smtOrder",
				component: () => import("@/view/smtOrder/index.vue"),			// 组装工单
				meta: {
					keepAlive: true
				}
			},
			{
				path: "cartonOrder",
				component: () => import("@/view/cartonOrder/index.vue"),			// 包装工单
				meta: {
					keepAlive: true
				}
			},
			{
				path: "qc",
				component: () => import("@/view/qc/index.vue"),			// 品质检验
				meta: {
					keepAlive: true
				}
			},
			{
				path: "shipmentOrder",
				component: () => import("@/view/shipmentOrder/index.vue"),			// 发货工单
				meta: {
					keepAlive: true
				}
			},
			{
				path: "productModel",
				component: () => import("@/view/productModel/index.vue"),			// 产品型号
				meta: {
					keepAlive: true
				}
			},
			{
				path: "factoryTools",
				component: () => import("@/view/factoryTools/index.vue"),			// 产测工具
				meta: {
					keepAlive: true
				}
			},
			{
				path: "outwardOrder",
				component: () => import("@/view/outwardOrder/index.vue"),			// 产测工具
				meta: {
					keepAlive: true
				}
			},
			{
				path: "labelTemplate",
				component: () => import("@/view/labelTemplate/index.vue"),			// 标签模板
				meta: {
					keepAlive: true
				}
			},
			{
				path: "sap",
				component: () => import("@/view/sap/index.vue"),			// SAP报工
				meta: {
					keepAlive: true
				}
			},
			{
				path: "badPartsOrder",
				component: () => import("@/view/badPartsOrder/index.vue"),			// 坏件登记
				meta: {
					keepAlive: true
				}
			},
			{
				path: "toolbox",
				component: () => import("@/view/toolbox/index.vue"),			// 工具箱
				meta: {
					keepAlive: true
				}
			},
			{
				path: "customerManage",
				component: () => import("@/view/customerManage/index.vue"),			// 客户管理
				meta: {
					keepAlive: true
				}
			},
			{
				path: "deviceManage",
				component: () => import("@/view/deviceManage/index.vue"),				// 产品/SN管理
				meta: {
					keepAlive: true
				}
			},
			{
				path: "itemCodeManage",
				component: () => import("@/view/itemCodeManage/index.vue"),			// 物料管理
				meta: {
					keepAlive: true
				}
			},
			{
				path: "userManage",
				component: () => import("@/view/userManage/index.vue"),				// 用户管理
				meta: {
					keepAlive: true
				}
			},
			{
				path: "plantSetting",
				component: () => import("@/view/plantSetting/index.vue"),			// 工厂设置
				meta: {
					keepAlive: true
				}
			},
			{
				path: "archiveMamage",
				component: () => import("@/view/archiveMamage/index.vue"),			// 附件管理
				meta: {
					keepAlive: true
				}
			},
			{
				path: "systemLog",
				component: () => import("@/view/systemLog/index.vue"),			// 系统日志
				meta: {
					keepAlive: true
				}
			},
		]
	},
	{
		path: "/productSystem",
		component: () => import("@/view/productSystem/index.vue"),
		meta: {
			keepAlive: true
		}
	},
]

const router = new vueRouter({
	mode: "history",
	routes
})

const whitePaths = ['/login'];
const productSystem = ['/productSystem'];
const agent = navigator.userAgent.toLowerCase()
// console.log(agent)
router.beforeEach((to, from, next) => {
	// console.log(to)
	if ((agent.includes('chrome') || agent.includes('firefox') || agent.includes('safari')) && !agent.includes("edge")) {
		if (to.path != '/login') {
			store.state.directVisitUrl = to.fullPath
		}
		if (whitePaths.includes(to.path.toLowerCase())) {
			next()
		} else {
			if (store.state.userInfo.accessToken) {
				if(store.state.userInfo.isAllowLogin) {
					next();
				} else {
					if(productSystem.includes(to.path)) {
						next();
					} else {
						Message.warning('暂无权限访问系统后台页面, 请联系系统管理员申请权限');
						next("/productSystem")
					}
				}
			} else {
				store.state.userInfo = {}
				Message.warning('请先登录再进行访问')
				next('/login')
			}
		}
	} else {
		Message({
			type: 'error',
			dangerouslyUseHTMLString: true,
			message: '<h3>IE已死，请使用“Chrome谷歌浏览器”、“FireFox火狐”、“Safari”或“Microsoft Edge”等浏览器进行访问！</h3>',
			duration: 0,
			offset: '200'
		})
	}
})
router.onError((error) => {
	const pattern = /Loading chunk chunk-(\w)+ failed/g;
	const isChunkLoadFailed = error.message.match(pattern);
	const targetPath = router.history.pending.fullPath;
	if (isChunkLoadFailed) {
		location.href = location.origin + targetPath;
		Message.warning('新版本发布更新, 已重新加载页面')
	}
})

// 记录最后打开的一级模块（左侧菜单对应的一级模块），供重新打开/登录后直达
router.afterEach((to) => {
	if (/^\/homePage\//.test(to.path)) {
		setLastModulePath(to.path);
	}
})

export default router